export default "__VITE_ASSET__FZSmED_g__"